/* Marobali — habillage de la pop-up « -10 % première commande » (app Pop-Convert, affichée dans un shadow DOM) */
(function () {
	var CSS = [
		"#pc-modal-backdrop{background:rgba(35,38,67,.5) !important;-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px)}",
		"#pc-modal-backdrop .modal-card{border:0 !important;border-radius:28px !important;overflow:visible !important;box-shadow:0 40px 90px -30px rgba(35,38,67,.55) !important;background:#fff !important}",
		"#pc-modal-backdrop .modal-hero-container{border-radius:28px !important;overflow:hidden !important}",
		"#pc-modal-backdrop .modal-content{border-radius:0 !important;background:#fff !important}",
		"#pc-modal-backdrop .text-block h1{margin:0 0 12px !important;font-family:'Young Serif',Georgia,serif !important;font-weight:400 !important;font-size:30px !important;line-height:1.15 !important;letter-spacing:-.01em !important;color:#232643 !important}",
		"@media (max-width:600px){#pc-modal-backdrop .text-block h1{font-size:25px !important}}",
		"#pc-modal-backdrop .text-block p{font-family:'Jost',system-ui,sans-serif !important;font-size:16px !important;line-height:1.5 !important;color:#4a4d68 !important}",
		"#pc-modal-backdrop .text-block p:empty{display:none !important}",
		"#pc-modal-backdrop .input-wrapper{border:0 !important}",
		"#pc-modal-backdrop .form-block-input{height:54px !important;padding-left:46px !important;border:1.5px solid #dfe3fb !important;border-radius:14px !important;background:#fff !important;font-family:'Jost',system-ui,sans-serif !important;font-size:16px !important;color:#232643 !important;text-align:left !important;box-shadow:none !important;outline:none !important;transition:border-color .2s ease}",
		"#pc-modal-backdrop .form-block-input:focus{border-color:#2f3fd0 !important}",
		"#pc-modal-backdrop .input-wrapper svg{color:#2f3fd0 !important}",
		"#pc-modal-backdrop .submit-button{height:54px !important;border:0 !important;border-radius:14px !important;background:#2f3fd0 !important;font-family:'Jost',system-ui,sans-serif !important;font-size:16px !important;font-weight:600 !important;letter-spacing:.01em !important;color:#fff !important;box-shadow:none !important;transition:background .2s ease !important}",
		"#pc-modal-backdrop .submit-button:hover{background:#2433b8 !important}",
		/* Encart du code : masqué tant que le code n'est pas révélé (plus de ciseaux ni de pointillés) */
		"#pc-modal-backdrop .coupon-block{display:none !important}",
		"#pc-modal-backdrop .coupon-block.mb-has-code{display:block !important;position:relative !important;margin:6px 0 0 !important;padding:16px 18px 14px !important;border:1.5px solid #dfe3fb !important;border-radius:16px !important;background:#eef0fd !important;text-align:center !important;cursor:pointer;transition:border-color .2s ease,background-color .2s ease}",
		"#pc-modal-backdrop .coupon-block.mb-has-code:hover{border-color:#2f3fd0 !important}",
		"#pc-modal-backdrop .coupon-block.mb-has-code svg{display:none !important}",
		"#pc-modal-backdrop .coupon-block.mb-has-code *{border:0 !important;background:transparent !important;box-shadow:none !important;outline:none !important;font-family:'Jost',system-ui,sans-serif !important;font-size:22px !important;font-weight:600 !important;letter-spacing:.14em !important;color:#2f3fd0 !important;text-align:center !important}",
		"#pc-modal-backdrop .coupon-block.mb-has-code::before{content:'Votre code de bienvenue';display:block;margin:0 0 6px;font-family:'Jost',system-ui,sans-serif;font-size:12px;font-weight:500;letter-spacing:.12em;text-transform:uppercase;color:#6a6d8a}",
		"#pc-modal-backdrop .coupon-block.mb-has-code::after{content:attr(data-mb-hint);display:inline-flex;align-items:center;margin:10px auto 0;padding:5px 12px;border-radius:999px;background:#fff;font-family:'Jost',system-ui,sans-serif;font-size:13px;font-weight:600;letter-spacing:.01em;color:#2f3fd0}",
		"#pc-modal-backdrop .divider-block{display:none !important}",
		"#pc-modal-backdrop .social-networks-block a{display:inline-flex !important;align-items:center;justify-content:center;width:44px;height:44px;border-radius:50%;background:#eef0fd;transition:background .2s ease}",
		"#pc-modal-backdrop .social-networks-block a:hover{background:#dfe3fb}",
		"#pc-modal-backdrop .social-networks-block a svg{color:#2f3fd0 !important;fill:currentColor}",
		"#pc-modal-backdrop #pc-main-close-button{width:40px;height:40px;display:flex !important;align-items:center;justify-content:center;padding:0 !important;border:0 !important;background:#eef0fd !important;color:#232643 !important;box-shadow:0 6px 16px -6px rgba(35,38,67,.4) !important}"
	].join('\n');

	function codeOf(block) {
		var t = (block.textContent || '').replace(/[\s‐-―_\-·.]+/g, '');
		var m = t.match(/[A-Z0-9]{4,}/);
		return m ? m[0] : '';
	}

	function syncCoupons(root) {
		var blocks = root.querySelectorAll('.coupon-block');
		for (var i = 0; i < blocks.length; i++) {
			var b = blocks[i];
			var code = codeOf(b);
			if (code) {
				b.classList.add('mb-has-code');
				b.dataset.mbCode = code;
				if (!b.dataset.mbHint) b.dataset.mbHint = 'Cliquez pour copier';
				if (!b.__mbClick) {
					b.__mbClick = true;
					b.addEventListener('click', function () {
						var el = this, c = el.dataset.mbCode;
						var done = function () { el.dataset.mbHint = 'Copié ✓'; setTimeout(function () { el.dataset.mbHint = 'Cliquez pour copier'; }, 2000); };
						if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(c).then(done, done); } else { done(); }
					});
				}
			} else {
				b.classList.remove('mb-has-code');
			}
		}
	}

	function apply(root) {
		if (!(root.getElementById && root.getElementById('mb-pc-style'))) {
			var s = document.createElement('style');
			s.id = 'mb-pc-style';
			s.textContent = CSS;
			root.appendChild(s);
		}
		syncCoupons(root);
	}

	var tries = 0;
	var timer = setInterval(function () {
		tries++;
		var host = document.getElementById('pop-convert-app');
		if (host && host.shadowRoot) {
			apply(host.shadowRoot);
			if (!host.__mbObs) {
				host.__mbObs = new MutationObserver(function () { apply(host.shadowRoot); });
				host.__mbObs.observe(host.shadowRoot, { childList: true, subtree: true, characterData: true });
			}
		}
		if (tries > 240) { clearInterval(timer); }
	}, 500);
})();
